import { QrCode, Mail, MapPin } from 'lucide-react';
import { useTranslation } from '../i18n';

const quickLinks = [
  { titleKey: 'footer.sections.quickLinks.services', href: '#services' },
  { titleKey: 'footer.sections.quickLinks.pricing', href: '#pricing' },
  { titleKey: 'footer.sections.quickLinks.about', href: '#about' },
  { titleKey: 'footer.sections.quickLinks.faq', href: '#faq' },
  { titleKey: 'footer.sections.quickLinks.contact', href: '#contact' },
];

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#0A1A33] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-[#C6A667] mb-4">{t('footer.brand.title')}</h3>
            <p className="text-white/60 text-sm leading-relaxed mb-4">
              {t('footer.brand.description')}
            </p>
            <p className="text-white/40 text-xs">
              {t('footer.brand.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white mb-4">{t('footer.sections.quickLinks.title')}</h4>
            <p className="text-xs text-white/40 mb-4">{t('footer.sections.quickLinks.subtitle')}</p>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a 
                    href={link.href}
                    className="text-white/60 hover:text-[#C6A667] transition-colors text-sm block"
                  >
                    {t(link.titleKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white mb-4">{t('footer.sections.contact.title')}</h4>
            <p className="text-xs text-white/40 mb-4">{t('footer.sections.contact.subtitle')}</p>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <Mail className="w-4 h-4 text-[#C6A667] mt-1 flex-shrink-0" />
                <div>
                  <a href="mailto:info@aurenstratus.com" className="text-white/60 hover:text-[#C6A667] transition-colors">
                    {t('footer.sections.contact.email')}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <MapPin className="w-4 h-4 text-[#C6A667] mt-1 flex-shrink-0" />
                <span className="text-white/60">{t('footer.sections.contact.location')}</span>
              </li>
            </ul>
          </div>

          {/* WeChat QR */}
          <div>
            <h4 className="text-white mb-4">{t('footer.sections.wechat.title')}</h4>
            <p className="text-xs text-white/40 mb-4">{t('footer.sections.wechat.subtitle')}</p>
            <div className="bg-white p-4 rounded-lg inline-flex items-center justify-center">
              <QrCode className="w-24 h-24 text-[#0A1A33]" />
            </div>
            <p className="text-xs text-white/40 mt-3">{t('footer.sections.wechat.scan')}</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/40">
              {t('footer.legal.copyright')}
            </p>
            <p className="text-xs text-white/30 text-center md:text-right max-w-xl">
              {t('footer.legal.disclaimer')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
